<div *ngIf="selectedMimic" class="options-container">
    <div class="mimic-name tool-box">
        <h5 class="title">
            {{ 'mimic-drawing.mimic-name' | translate }}
        </h5>
        <div class="mimic-name-container tool-list">
            <app-channel-text-input
                [dark]="true"
                [value]="selectedMimic.name"
                [label]="'mimic-drawing.mimic-name.label'"
                [name]="'name'"
                [maxLength]="40"
                [inputError]="validationErrors?.name"
                (onInputChange)="handleNameChange($event.value)"
                (onFocusChange)="handleNameChange($event.value)"></app-channel-text-input>
        </div>
    </div>

    <div class="mimic-name tool-box">
        <h5 class="title">
            {{ 'mimic-drawing.mimic-bgcolor' | translate }}
        </h5>
        <div class="title-container">
            <h6 class="sub-title contain-icon margin-top">
                {{ 'mimic-drawing.bgcolor-fill' | translate }}
                <mat-icon
                    class="icon-pointer"
                    (click)="mimicFillIconClick()"
                    [svgIcon]="showColorOptions ? 'visible' : 'hidden'"></mat-icon>
            </h6>
        </div>
        <div class="fill-input-container">
            <app-editor-input-color
                name="mimicFill"
                [value]="selectedMimic?.profile.bkcolor"
                (onInputChange)="updateBackground($event)">
            </app-editor-input-color>
        </div>
    </div>

    <div class="mimic-name tool-box">
        <div class="title-container">
            <h5 class="sub-title contain-icon margin-top">
                {{ 'mimic-drawing.mimic-grid' | translate }}
                <mat-icon
                    class="icon-pointer"
                    (click)="gridToggleChange()"
                    [svgIcon]="selectedMimic?.profile.allowGrid ? 'visible' : 'hidden'"></mat-icon>
            </h5>
        </div>
        <div class="mimic-grid-container tool-list">
            <app-editor-input-text
                [readonly]="!selectedMimic?.profile.allowGrid"
                [shouldEmitOnBlur]="true"
                (onInputChange)="handleInputChange($event)"
                name="gridSpacing"
                label="Grid spacing"
                [value]="gridValue"
                type="text"
                [maxlength]="3"
                [maxValue]="200"
                [minValue]="0.1">
            </app-editor-input-text>
            <div class="grid-input-button-container">
                <button
                    class="grid-input-button"
                    (mouseup)="onMouseUp()"
                    (mousedown)="gridInputButtonClick('plus')"
                    (mouseleave)="onMouseUp()">
                    <mat-icon svgIcon="plus"></mat-icon>
                </button>
                <button
                    class="grid-input-button"
                    (mouseup)="onMouseUp()"
                    (mousedown)="gridInputButtonClick('minus')"
                    (mouseleave)="onMouseUp()">
                    <mat-icon svgIcon="minus"></mat-icon>
                </button>
            </div>
        </div>
        <div class="title-container">
            <h6 class="sub-title contain-icon margin-top">
                {{ 'mimic-drawing.mimic-color' | translate }}
            </h6>
        </div>
        <div class="fill-input-container">
            <app-editor-input-color
                name="mimicColor"
                [value]="selectedMimic?.profile.color"
                (onInputChange)="updateGridColor($event)">
            </app-editor-input-color>
        </div>
    </div>
</div>
